import React, { useContext } from 'react'
import { Select, Well } from '@pushly/aqe/lib/components'
import { getClassNames } from '../../../../_utils/classnames'
import PreviewSDK, { Browser } from '@pushly/cuttlefish'
import { PromptEditorContext } from '../context'
import { PromptStyle } from '@pushly/models/lib/enums/prompts/prompt-style'
import { Flex, Space } from 'antd'

export const PromptPreview = () => {
    const { loading, domain, selectedPrompt } = useContext(PromptEditorContext)

    const [browser, setBrowser] = React.useState<Browser>(Browser.CHROME)

    const style = selectedPrompt?.style ?? PromptStyle.NATIVE
    const config = selectedPrompt?.config?.serialize() ?? {}

    return (
        <Well
            className={getClassNames('prompt-preview')}
            disabled={false}
            hideFooter={true}
            mode="default"
            title="Preview"
        >
            <Flex vertical gap={8}>
                <Select
                    prefix="Browser:"
                    aria-label="Preview browser"
                    showSearch={false}
                    defaultValue={[browser]}
                    value={[browser]}
                    onChange={(val: Browser) => {
                        if (val && Object.values(Browser).includes(val)) {
                            setBrowser(val)
                        }
                    }}
                    options={[
                        {
                            value: Browser.CHROME,
                            label: 'Chrome',
                        },
                        {
                            value: Browser.FIREFOX,
                            label: 'FireFox',
                        },
                        {
                            value: Browser.EDGE,
                            label: 'Edge',
                        },
                        {
                            value: Browser.SAFARI,
                            label: 'Safari',
                        },
                    ]}
                    style={{ width: '100%' }}
                />

                <PreviewSDK.PromptPreview
                    loading={loading}
                    domain={(domain ?? {}) as React.ComponentProps<typeof PreviewSDK.PromptPreview>['domain']}
                    template={{
                        title: 'Prompt Preview',
                        style: style.toLowerCase(),
                        config,
                    }}
                    browser={browser}
                    version={'new'}
                    backgroundColor={'#fff'}
                    systemMode={'light'}
                />
            </Flex>
        </Well>
    )
}
